import * as z from 'zod/v4'
import { ZodRawShape } from 'zod/v4'

/** Synthetic tool argument key used to pass through model reasoning text. */
export const LLM_REASONING_ARG_NAME = 'frisk__llmReasoning'

const LLM_REASONING_ARG_DESCRIPTION =
  "The LLM's reasoning process for this tool call, captured as a string. This should include the LLM's thought process, any intermediate steps, and how it arrived at the final arguments for the tool call."

export const llmReasoningZodShape: ZodRawShape = {
  [LLM_REASONING_ARG_NAME]: z.string().describe(LLM_REASONING_ARG_DESCRIPTION),
}
